export default __webpack_public_path__ + "ad71dd84f4990533c43d550a8eb1b523.jpg";